import useAxios from 'hooks/useAxios'
import constants from 'config/constants'

export function useDynamicConstants() {
  const { data: surveyConfigurations } = useAxios({
    url: constants.surveyConfigurationsUrl,
  })

  if (!surveyConfigurations) {
    return {
      embedSurveyTypes: [],
      surveyConfigurations: [],
    }
  } else {
    return {
      embedSurveyTypes: surveyConfigurations.map((surveyConfiguration) => surveyConfiguration.name),
      surveyConfigurations,
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/config/dynamicConstants.js